import { DashboardStatus } from '../constants/integrationTypes';

export interface RiskDetail {
  type: 'unallocated' | 'delayed' | 'blocked' | 'at_risk';
  count: number;
  entityType: string;
}

export const isAtRiskStatus = (status?: string): boolean => {
  return (status || '').toLowerCase() === DashboardStatus.AT_RISK;
};

export const getRiskDetailsFromStats = (
  stats?: {
    total?: number;
    unallocated?: number;
    delayed?: number;
    blocked?: number;
    at_risk?: number;
    // Roadmap-specific stats
    delayed_projects?: number;
    unallocated_projects?: number;
    blocked_projects?: number;
    at_risk_projects?: number;
  } | null,
  childEntityType?: string
): RiskDetail[] => {
  const riskDetails: RiskDetail[] = [];

  if (!stats) return riskDetails;

  // Check both project stats and roadmap stats (combined)
  const blockedCount = (stats.blocked || 0) + (stats.blocked_projects || 0);
  const unallocatedCount = (stats.unallocated || 0) + (stats.unallocated_projects || 0);
  const delayedCount = (stats.delayed || 0) + (stats.delayed_projects || 0);
  const atRiskCount = (stats.at_risk || 0) + (stats.at_risk_projects || 0);

  if (atRiskCount > 0) {
    riskDetails.push({
      type: 'at_risk',
      count: atRiskCount,
      entityType: childEntityType || 'work item'
    });
  }

  if (blockedCount > 0) {
    riskDetails.push({
      type: 'blocked',
      count: blockedCount,
      entityType: childEntityType || 'work item'
    });
  }

  if (unallocatedCount > 0) {
    riskDetails.push({
      type: 'unallocated',
      count: unallocatedCount,
      entityType: childEntityType || 'work item'
    });
  }

  if (delayedCount > 0) {
    riskDetails.push({
      type: 'delayed',
      count: delayedCount,
      entityType: childEntityType || 'work item'
    });
  }

  return riskDetails;
};